import { render, staticRenderFns } from "./view-more-new.vue?vue&type=template&id=9556f20c&scoped=true"
import script from "./view-more-new.vue?vue&type=script&lang=ts"
export * from "./view-more-new.vue?vue&type=script&lang=ts"
import style0 from "./view-more-new.vue?vue&type=style&index=0&id=9556f20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9556f20c",
  null
  
)

export default component.exports